/**
 * Registers the production service worker (Phase 2 PWA).
 * Skipped in development (HMR) and test; set REACT_APP_ENABLE_PWA_SW=false to disable.
 */
export function registerServiceWorker(): void {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }
  if (process.env.NODE_ENV !== "production") {
    return;
  }
  if (process.env.REACT_APP_ENABLE_PWA_SW === "false") {
    return;
  }

  window.addEventListener("load", () => {
    void navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .catch((err) => {
        console.warn("[PWA] Service worker registration failed:", err);
      });
  });
}
